// TransUnion Device Risk (iovation FraudForce) device fingerprint.
// The configuration object must exist on window before loader.js runs, otherwise the loader ignores it.
const LOADER_SRC = "/js/loader.js";
const BLACKBOX_KEY = "blackBox";

const loadDeviceRisk = () => {
  if (document.querySelector(`script[src="${LOADER_SRC}"]`)) {
    return;
  }

  // Every visit / refresh starts a new fingerprint session -- never reuse a blackbox from a previous page load
  sessionStorage.removeItem(BLACKBOX_KEY);

  window.io_global_object_name = "IGLOO";
  window.IGLOO = window.IGLOO || {
    bb_callback: (bb) => {
      sessionStorage.setItem(BLACKBOX_KEY, bb);
    },
    enable_flash: false,
    loader: {
      // No reverse proxy for TransUnion's first-party scripts (/iojs) -- collect via third-party script only
      fp_static: false,
      fp_dyn: false,
      version: "general5",
      subkey: process.env.REACT_APP_TRANSUNION_DEVICE_RISK_SUBKEY || "",
    },
  };

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = LOADER_SRC;
  script.async = true;
  document.head.appendChild(script);
};

// Best available blackbox at submit time. Empty is still sent so TransUnion can apply "Device not Provided".
const getBlackbox = () => {
  try {
    const current = window.IGLOO && typeof window.IGLOO.getBlackbox === "function"
      ? window.IGLOO.getBlackbox()
      : null;
    if (current && current.blackbox) {
      return current.blackbox;
    }
  } catch (e) {
    // fall back to the last value from bb_callback
  }
  return sessionStorage.getItem(BLACKBOX_KEY) || "";
};

const TransUnionDeviceRisk = { loadDeviceRisk, getBlackbox };

export default TransUnionDeviceRisk;
